import React, { Component } from 'react';
import $ from 'jquery';
import { findDOMNode } from 'react-dom';

export default class MissingInAction extends Component {

toggle = () => {
    let toggle = findDOMNode(this.refs.toggle);
    $(toggle).toggle();
}

	render() {
		return (
			<div>
                <iframe id="video" ref="toggle" src="https://www.youtube.com/embed/XmtqnX9-3-w" 
                title="Missing in Action"></iframe>
				<button
					type="button"
					className="btn missingInAction"
					onClick={this.toggle}
				>
					Missing in Action
				</button>
			</div>
		);
	}
}